import React, { useRef, createRef, useEffect, useCallback, useState, forwardRef, useImperativeHandle } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { is } from 'immutable'
import cn from 'classnames'
import { acceptOrder } from '@/models/orders/actions'
import { sendMessage } from '@/models/messages/actions'
import * as orderActions from '@/models/orders/actions';
import { currentOrderSelector, orderOfConvSelector, } from '@/models/conversations/selectors'
import * as orderSelectors from '@/models/orders/selectors'
import { Dropdown, Menu, Icon, Button, message, Spin, Input, Select } from 'antd'
import * as apis from '@/apis'
import * as utils from '@/utils'
import EmojiPicker from './emojiPicker'
import styles from './styles.module.less'
import SearchForm from '../SearchForm'
import { getCurrentUser } from '@/models/user/selectors';
const quickReplyMessages = [
  '您好，有师傅。到货了吗？',
  '您好，安排吗？如需安排请尽快确认工单价格，谢谢。',
  '您好，可以提供物流电话吗，我们和物流约时间一起过去？',
  '您好，因现场临时需要师傅搬运产品上楼，需申请新增搬运费用，稍后请确认，谢谢。',
  '您好，此工单我们需要远程调派师傅，需要支持远程费，稍后请确认。',
  '您好，保外单，由我们直接和客户沟通确认价格。',
  '您好，客户此号码无法接通，还有客户其他电话号码吗？',
  '您好，客户最近有事，说需要时会再联系师傅。',
  '您好，配件需要师傅返厂吗，返件信息发过来，到付还是寄付，发送什么快递是否有要求？',
  '您好，此工单配件客户是否已收到？',
  '您好，此问题需要重新创建工单，谢谢。',
  '您好，经我方核实产品问题是物流运输过程造成的，不是我们师傅的责任，请您核实，谢谢。',
  '您好，派单的时候可以把服务要求、已发配件、返件地址等信息一并填写到“服务描述”即可。',
  '您好，我马上联系相关师傅看能否安排，稍后请您留意系统消息，谢谢。'
]

const isTenantMode = process.env.APP_MODE === 'tenant';
const isManagerMode = process.env.APP_MODE === 'manager';

function EditorBox(props, ref) {
  // const order = useSelector(orderOfConvSelector(props.convId), is)
  const order = props.orderId ? useSelector(orderSelectors.findById(props.orderId)) : useSelector(orderOfConvSelector(props.convId), is);

  const [editorText, setEditorText] = useState('')
  const [uploadProgress, setUploadProgress] = useState(0)
  const [uploading, setUploadState] = useState(false)
  const $editor = useRef(null)
  const user = useSelector(getCurrentUser).toJS()
  const dispatch = useDispatch()

  const searchFormRef = useRef(null)

  useImperativeHandle(ref, () => ({
    searchData: (params = {}) => {
      searchFormRef.current?.searchData(params)
    }
  }))

  const onKeyDown = useCallback(event => {
    const hasExtKey = event.ctrlKey || event.altKey || event.metaKey || event.shiftKey
    if (event.keyCode === 13 && !hasExtKey) {
      event.preventDefault()
      if (event.target.value.trim() === '') return
      dispatch(sendMessage({
        order_id: order.get('_id'),
        message_type: 'text',
        text: event.target.value.trim()
      }))

      setEditorText('')
      if (document.getElementById('messagesScrollBox')) {
        document.getElementById('messagesScrollBox').scrollTop = 99999999
      }
    }
  }, [order])
  const onClickSend = useCallback(() => {
    if (!order) return false
    if (editorText.trim() === '') return
    dispatch(sendMessage({
      order_id: order.get('_id'),
      message_type: 'text',
      text: editorText.trim()
    }))

    setEditorText('')
    if (document.getElementById('messagesScrollBox')) {
      document.getElementById('messagesScrollBox').scrollTop = 99999999
    }

  }, [order, editorText])
  const showAssignDialogHandler = useCallback(() => {
    dispatch(
      orderActions.showAssignDialog({
        title: '指给客服',
        id: order?.toJS()._id,
      })
    );
  });
  const handleImgChange = useCallback(event => {
    if (!order) return false
    // TODO 本地压缩大小
    // TODO 如果太大话需要提示上传失败
    const file = event.target.files[0]
    const formData = new FormData()

    formData.append('file', file)
    formData.append('type', 'message-images')

    setUploadState(true)

    apis.uploadFile(formData, {
      onUploadProgress: event =>
        setUploadProgress(parseInt(event.loaded / event.total))
    }).then(result => {
      dispatch(sendMessage({
        order_id: order.get('_id'),
        message_type: 'image',
        image: result._id
      }))
    }).catch(err => {
      message.error('图片上传失败，请重试')
      console.log(err)
    }).finally(() => {
      setUploadState(false)
    })
  }, [order])

  const receiveOrder = useCallback(() => {
    dispatch(acceptOrder(order.get('_id'), localStorage.getItem(`current_conv_item_${process.env.APP_MODE}`)))
  }, [order])

  const emojiSelect = useCallback(text => {
    setEditorText(editorText + text)

    $editor.current.focus()
  })

  const handleQuickReply = useCallback((data) => {
    if (!order) return false
    const msg = data?.item?.props?.title

    dispatch(sendMessage({
      order_id: order.get('_id'),
      message_type: 'text',
      text: msg
    }))
  }, [order])

  useEffect(() => {
    $editor.current.focus()
  }, [order])

  const menu = (
    <Menu onClick={handleQuickReply}>
      {
        quickReplyMessages.map((msg, idx) => (
          <Menu.Item key={idx} title={msg}>
            <div className={styles.quickReplyMsgItem}>{msg}</div>
          </Menu.Item>
        ))
      }
    </Menu>
  )

  return (
    <Spin spinning={uploading} tip={`正在上传图片 ${uploadProgress}%`}>
      <div className={styles.editorBox}>
        {order ? (<>
          {/* {
            //是自己的，并且尚未接单的 可以选择是否接单
            process.env.APP_MODE === 'manager' && (order.get('receive_state') === 0) &&
            (!order.get('assignTo') || order.toJS().assignTo?._id === user._id) && (
              <div className={styles.receiveWrap}>
                <p>请确认接收当前工单</p>
                <div>
                  <Button onClick={receiveOrder} type="primary">接收</Button>
                </div>
              </div>
            )
          } */}
          {/* {
            //不是自己的，无论是否接单了，都可以选择是否指派
            process.env.APP_MODE === 'manager' && order.get('receive_state') === 1 &&
            (order.toJS().assignTo?._id !== user._id)
            && (
              <div className={styles.receiveWrap}>
                <p>请确认是否指派当前工单</p>
                <div>
                  <Button onClick={showAssignDialogHandler} type="primary">指派</Button>
                </div>
              </div>
            )
          } */}
          {
            // order.get('active_state') === 0 && (
            //   <div className={styles.archived}>
            //     <Icon type="warning" style={{ fontSize: 30 }} />
            //     <p>当前工单已归档</p>
            //   </div>
            // )
          }
        </>) : (<>
          <div className={styles.archived}>
            {/* <Icon type="warning" style={{ fontSize: 30 }} /> */}
            {/* <p>请在 <b>我的信息</b> 中选择工单</p> */}
            <p>请先选择工单</p>
          </div>
        </>)}
        <div className={styles.editorPanel}>
          <div>
            <div className={styles.editorBtn} title="表情">
              <EmojiPicker onSelect={emojiSelect}>
                <i className={cn('iconfont', styles.icon)}>&#xe646;</i>
              </EmojiPicker>
            </div>
            <label className={styles.editorBtn} title="图片">
              <i className={cn('iconfont', styles.icon)}>&#xe695;</i>
              <input
                type="file"
                className={styles.fileInput}
                accept="image/*"
                onChange={handleImgChange} />
            </label>
            {
              isManagerMode && (
                <Dropdown overlay={menu} placement="topLeft">
                  <label className={styles.editorBtn} title="快速回复语">
                    <i className={cn('iconfont', styles.icon)}>&#xe6ca;</i>
                    {/* <span className={styles.text}>快速回复语</span> */}
                  </label>
                </Dropdown>
              )
            }
          </div>
          <div style={{ width: '340px' }}>
            <SearchForm size="small" onChangeSearchData={props?.onChangeSearchData}
              // ref={searchFormRef}
              wrappedComponentRef={searchFormRef}
            />
          </div>
          {/* {isManagerMode && <div>
            <Input.Group compact style={{ width: '250px' }}>
              <Select size="small" defaultValue="聊天历史" style={{ width: '90px' }}>
                <Select.Option value="聊天历史">聊天历史</Select.Option>
              </Select>
              <Input size="small"
                suffix={
                  <Icon type="search" style={{ color: '#17A55C' }} onClick={() => {
                    console.log(999999999)
                  }} />
                }
                style={{ width: '160px' }} />
            </Input.Group>
            <Select size="small" defaultValue="全部状态" style={{ width: '90px' }}>
              <Select.Option value="全部状态">全部状态</Select.Option>
            </Select>
          </div>} */}
        </div>
        <div className={styles.editor}>
          <textarea
            ref={$editor}
            placeholder="请输入内容"
            autoFocus
            value={editorText}
            onChange={event => setEditorText(event.target.value)}
            onKeyDown={onKeyDown} />
        </div>
        <div className={styles.btns}><Button onClick={onClickSend}>发送</Button></div>
      </div>
    </Spin>
  )
}
export default forwardRef(EditorBox)